var map = {
	"./de-DE.ts": [
		33774,
		"src_assets_i18n_de-DE_ts"
	],
	"./en-US.ts": [
		55917,
		"src_assets_i18n_en-US_ts"
	],
	"./es-ES.ts": [
		98892,
		"src_assets_i18n_es-ES_ts"
	],
	"./fr-FR.ts": [
		36748,
		"src_assets_i18n_fr-FR_ts"
	],
	"./it-IT.ts": [
		43606,
		"src_assets_i18n_it-IT_ts"
	],
	"./ja-JP.ts": [
		8477,
		"src_assets_i18n_ja-JP_ts"
	],
	"./lang.ts": [
		1235
	],
	"./zh-CN.ts": [
		27547,
		"src_assets_i18n_zh-CN_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 83558;
module.exports = webpackAsyncContext;